var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page flex-col"},[_c('img',{staticClass:"img-div",attrs:{"src":require("../assets/images/shop/small-mall.png")}})])])
}]

export { render, staticRenderFns }